// WebSocket /ws/inbox con reconnect exponencial.
import { queryClient } from "./query-client";
import { toast } from "sonner";

type InboxEvent =
  | { type: "mention"; id: number; network: string }
  | { type: "alert"; alert_id: number; payload: Record<string, unknown> }
  | { type: "message"; conversation_id: number }
  | { type: "ping" };

let socket: WebSocket | null = null;
let reconnectAttempts = 0;
let manuallyClosed = false;

export function connectInboxWs() {
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
    return socket;
  }
  manuallyClosed = false;
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  const url = `${proto}//${window.location.host}/ws/inbox`;
  socket = new WebSocket(url);

  socket.onopen = () => {
    reconnectAttempts = 0;
  };

  socket.onmessage = (e) => {
    let event: InboxEvent;
    try {
      event = JSON.parse(e.data);
    } catch {
      return;
    }
    switch (event.type) {
      case "mention":
        queryClient.invalidateQueries({ queryKey: ["mentions"] });
        queryClient.invalidateQueries({ queryKey: ["dashboard"] });
        queryClient.invalidateQueries({ queryKey: ["unread-mentions"] });
        break;
      case "alert":
        toast.warning("Alerta de monitorización", {
          description: JSON.stringify(event.payload).slice(0, 200),
        });
        break;
      case "message":
        queryClient.invalidateQueries({ queryKey: ["conversations"] });
        queryClient.invalidateQueries({ queryKey: ["messages", event.conversation_id] });
        break;
      case "ping":
        break;
    }
  };

  socket.onclose = () => {
    if (manuallyClosed) return;
    reconnectAttempts++;
    const delay = Math.min(30_000, 1_000 * 2 ** Math.min(reconnectAttempts, 5));
    setTimeout(connectInboxWs, delay);
  };

  socket.onerror = () => {
    socket?.close();
  };

  return socket;
}

export function disconnectInboxWs() {
  manuallyClosed = true;
  socket?.close();
  socket = null;
}
